
import { useState, useRef, useEffect } from "react";
import Logo from "./Logo";
import MoreButton from "./MoreButton";
import { formatDate } from "../services/utils";

export default function PresentationCard({
  variant = "card",
  onClick,
  onDelete,
  deck,
}) {
  const [hovered, setHovered] = useState(false);
  const isPlus = variant === "plus";

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  useEffect(()=>{
    if(!hovered){
      setMenuOpen(false);
      //close the menu automatically when hover goes out
    }
  },[hovered])

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        ...styles.container,
        ...(hovered ? styles.containerHover : {}),
        ...(isPlus ? styles.plusContainer : {}),
      }}
    >
      {isPlus ? (
        <div style={styles.plusContent}>
          <span
            style={{
              ...styles.plusIcon,
              ...(hovered ? styles.plusIconHover : {}),
            }}
          >
            +
          </span>
          <p style={styles.plusText}>Create new</p>
        </div>
      ) : (
        <>
          <div style={styles.preview}>
            <Logo />
          </div>

          <div style={styles.info}>
            <p style={styles.title}>{deck.title}</p>

            <div style={styles.bottomRow}>
              <p style={styles.date}>{formatDate(deck.updatedAt)}</p>

              <div
                style={{
                  opacity: hovered ? 1 : 0,
                  pointerEvents: hovered ? "auto" : "none",
                  transition: "opacity 0.15s ease",
                  position: "relative",
                }}
                ref={menuRef}
              >
                <MoreButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setMenuOpen((v) => !v);
                  }}
                />

                {menuOpen && (
                  <div style={styles.menu}>
                    <button
                      style={styles.menuItemDanger}
                      onClick={(e) => {
                        e.stopPropagation();
                        setMenuOpen(false);
                        onDelete?.(deck.id);
                      }}
                    >
                      Delete
                    </button>
                    <button
                      style={styles.menuItemDanger}
                      onClick={(e) => {
                        e.stopPropagation();
                        setMenuOpen(false);
                      }}
                    >
                      some other option
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    width: 223,
    border: "1px solid #ddd",
    margin: 10,
    cursor: "pointer",
    background: "#fff",
    transition: "all 0.2s ease",
  },
  containerHover: {
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
  },

  /* PLUS VARIANT */
  plusContainer: {
    justifyContent: "center",
    alignItems: "center",
  },
  plusContent: {
    height: "100%",
    minHeight: "12rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },
  plusIcon: {
    fontSize: 48,
    fontWeight: 300,
    lineHeight: 1,
    color: "#999",
    transition: "all 0.2s ease",
  },
  plusIconHover: {
    color: "#3B00FF",
    transform: "scale(1.1)",
  },
  plusText: {
    margin: 0,
    fontSize: 14,
    color: "#666",
  },

  /* EXISTING */
  preview: {
    height: "9rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderBottom: "1px solid #eee",
    background: "#fafafa",
  },
  info: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
    gap: 6,
  },
  bottomRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    margin: 0,
  },
  date: {
    margin: 0,
    color: "#666",
  },
  menu: {
  position: "absolute",
  top: 28,
  right: 0,
  background: "#fff",
  border: "1px solid #ddd",
  borderRadius: 8,
  boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
  minWidth: 140,
  zIndex: 10,
  overflow: "hidden",
},

menuItemDanger: {
  width: "100%",
  padding: "10px 12px",
  background: "none",
  border: "none",
  textAlign: "left",
  cursor: "pointer",
  color: "#d32f2f",
  fontSize: 14,
}
};
